import {
    RECEIVE_MESSAGE,
    FETCH_MESSAGES,
    MESSAGES_FETCHED,
    SEND_MESSAGE,
    PLAY_ACTION_AUDIO,
    REMOVE_MESSAGE
} from './actionTypes'

export const receiveMessage = payload => ({ type: RECEIVE_MESSAGE, payload })
export const fetchMessages = payload => ({ type: FETCH_MESSAGES, payload })
export const messagesFetched = payload => ({ type: MESSAGES_FETCHED, payload })
export const sendMessage = payload => ({ type: SEND_MESSAGE, payload })
export const removeMessage = payload => ({ type: REMOVE_MESSAGE, payload })
export const playActionAudio = () => ({ type: PLAY_ACTION_AUDIO })


